import React from "react";

// components
import DataTable from "../../../component/element/table";

// types and dispatch
import {
  delete_type,
  get_opportunities_type,
} from "../../../services/apis/opportunity";
import { useAppDispatch, useAppSelector } from "../../../store";
import { ColumnDef } from "@tanstack/react-table";
import { IOpportunityTypes } from "../../../store/types/opportunity";
import { FaComputer, FaPersonWalking } from "react-icons/fa6";
import ItemAction from "../../../component/ui/action/ItemAction";

const TypeTable = () => {
  const dispatch = useAppDispatch();
  const types = useAppSelector(
    ({ opportunity }) => opportunity.opportunity_types
  );

  const onLoad = React.useCallback(() => {
    get_opportunities_type(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<IOpportunityTypes>[] = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue }) => {
        const type = getValue() as string;

        // Define background colors for different types
        const bgColors = {
          physical: "bg-blue-50 text-blue-800", // Soft Blue for Physical
          online: "bg-yellow-50 text-yellow-800", // Soft Green for Online
        };

        return (
          <span className={`rounded-md flex items-center`}>
            {type && (
              <div
                className={`flex items-center gap-2 text-xs font-medium px-2 py-1 rounded-full  capitalize ${bgColors[type as keyof typeof bgColors]}`}
              >
                <span>
                  {type === "physical" ? <FaPersonWalking /> : <FaComputer />}
                </span>
                <span>{type}</span>
              </div>
            )}
          </span>
        );
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ getValue }) => {
        const status = getValue() as string;
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${status === "1" ? "bg-primary-100/50 text-primary-500" : "bg-red-50 text-red-800"}`}
          >
            {status === "1" ? "active" : "not active"}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue() as string;
        return (
          <div className="flex">
            <ItemAction
              show_edit={false}
              show_view={false}
              onView={() => null}
              onEdit={() => null}
              onDelete={() => delete_type(id, dispatch)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable columns={columns} data={types} />
    </>
  );
};

export default TypeTable;
